import React, { FC } from 'react'
import { WrapperVideo } from '../../../../models/others/video'
import { RichTextWrapper } from '../../../../styles/global'
import Button from '../../button'
import Typography from '../../typography'
import VideoCta from '../../videoCta/videoCta'

type Props = {
  eyebrow: string
  heading: string
  cardBody: any
  cardUrl: string
  ctaText: string
  resourceDetail: any
  secondaryCtaUrlVal: string
  secondaryCtaTextVal: string
  video: WrapperVideo
  useCase: string
}

export const ResourceTexts: FC<Props> = ({
  eyebrow,
  heading,
  cardBody,
  cardUrl,
  ctaText,
  resourceDetail,
  secondaryCtaUrlVal,
  secondaryCtaTextVal,
  video,
  useCase,
}) => {
  const videoOverlayData = {
    video: {
      image: video?.image?.file?.url || '',
      altText: video?.altText || '',
      start: video?.start || '',
      animationFile: video?.animationFile?.file?.url || '',
      url: '',
      id: '',
      type: '',
    },
  }

  if (video?.youtubeId) {
    videoOverlayData.video.id = video.youtubeId
    videoOverlayData.video.type = 'youtube'
  }

  if (video?.vimeoId) {
    videoOverlayData.video.id = video.vimeoId
    videoOverlayData.video.type = 'vimeo'
  }

  if (video?.videoUrl) {
    videoOverlayData.video.url = video.videoUrl
    videoOverlayData.video.type = 'html-video'
  }

  if (video?.tencentVideoUrl) {
    videoOverlayData.video.url = video.tencentVideoUrl
    videoOverlayData.video.type = 'tencent-video'
  }

  return (
    <div className="FeaturedResource__Inner-Text">
      {eyebrow && (
        <Typography className="FeaturedResource__Eyebrow" type="captionAlt">
          {eyebrow}
        </Typography>
      )}

      {heading && (
        <Typography className="FeaturedResource__Inner-Heading" type="header4">
          {heading}
        </Typography>
      )}

      {cardBody && (
        <div className="FeaturedResource__Inner-Body__RichText">
          <RichTextWrapper $type="body" className="FeaturedResource__Inner-Body RichText">
            {cardBody}
          </RichTextWrapper>
        </div>
      )}

      <div className="FeaturedResource__CTA-Container">
        {video ? (
          <VideoCta
            width={'100%'}
            height="auto"
            videoId={videoOverlayData.video.id}
            videoUrl={videoOverlayData.video.url}
            type={videoOverlayData.video.type}
            ctaText={ctaText}
            ctaType={useCase === 'full width' ? 'primary' : 'secondary'}
            ctaTheme={'light'}
            ctaSize={'small'}
            className="Video__CTA"
          />
        ) : (
          <Button
            icon={true}
            href={cardUrl}
            text={ctaText ? ctaText : ''}
            type={useCase === 'full width' ? 'primary' : 'secondary'}
            size="small"
            className="FeaturedResource__CTA-1"
            theme={resourceDetail.theme}
          />
        )}

        {resourceDetail.cta && secondaryCtaUrlVal && (
          <Button
            icon={true}
            href={secondaryCtaUrlVal}
            text={secondaryCtaTextVal ? secondaryCtaTextVal : ''}
            type="text-link"
            size="small"
            className="FeaturedResource__CTA-2"
            theme={resourceDetail.theme}
          />
        )}
      </div>
    </div>
  )
}
